import * as GC from '@grapecity/spread-sheets';
import { fittingString } from './ellipsis-cell-type';

export function DiscStartCellType(color: string, stroke: boolean = false, ellipsisMaxWidth: any) {
  function _DiscStartCellType(_color: string) {
    this.discColor = _color || '#cccccc';
    this.typeName = 'DiscStartCellType';
  }

  function customPaint(ctx, value, x, y, w, h, style, context) {
    if (!ctx) {
      return;
    }

    if (ellipsisMaxWidth && ellipsisMaxWidth > 0) {
      // Ellipsis
      const maxWidth = ellipsisMaxWidth;
      value = fittingString(ctx, value, maxWidth);
    }
    ctx.save();

    // draw inside the cell's boundary
    ctx.rect(x, y, w, h);
    ctx.clip();

    // draw text and color disc
    const paintParams = [ctx, value, x + 20, y, w - 20, h, style, context];
    GC.Spread.Sheets.CellTypes.Base.prototype.paint.apply(this, paintParams);
    ctx.beginPath();
    ctx.fillStyle = this.discColor;
    const verticalPosition = y + h / 2;
    ctx.arc(x + 10, verticalPosition, 5, 0, 2 * Math.PI);
    ctx.fill();
    if (stroke) {
      ctx.stroke();
    }
    ctx.restore();
  }

  // Modify the prototype's paint
  _DiscStartCellType.prototype = new GC.Spread.Sheets.CellTypes.Base();
  _DiscStartCellType.prototype.paint = customPaint;

  const cellType = new _DiscStartCellType(color);
  return cellType;
}
